import toggleOn from "@assets/icons/switch_true.svg";
import toggleOff from "@assets/icons/switch_false.svg";

interface NotificationSwitchProps {
	isOn: boolean;
	label: string;
	isPending?: boolean;
	onToggle: () => void;
}

// Native button rather than the shared Button component: that one drops aria-*
// props, and a switch has to announce its state to a screen reader.
const NotificationSwitch = ({ isOn, label, isPending, onToggle }: NotificationSwitchProps) => (
	<button
		type="button"
		role="switch"
		aria-checked={isOn}
		aria-label={label}
		onClick={onToggle}
		disabled={isPending}
		className="clickable bg-transparent notification-switch"
	>
		<img src={isOn ? toggleOn : toggleOff} alt="" aria-hidden="true" className={isPending ? "op-5" : ""} />
	</button>
);

export default NotificationSwitch;
